import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import control from "./modules/control";
import documentSign from "./modules/documentSign";
import file from "./modules/file";
import process from "./modules/process";
import doe from "./modules/doe";
import user from "./modules/user";
import uploadFiles from "./modules/upload_files";
import downloadFiles from "./modules/download_files";
import giveKnowledge from "./modules/give_knowledge";
import timeline from "./modules/timeline";
import subscriber from "./modules/subscriber";
import routes from "./modules/routes";
import socket from "./modules/socket";
import broadcastChannel from "./modules/broadcastChannel";
import cacheData from "./modules/cacheData";

Vue.use(Vuex);

const userState = createPersistedState({
  storage: window.localStorage,
  paths: ["user", "cacheData"]
});

const dataState = createPersistedState({
  storage: window.sessionStorage,
  paths: ["process", "routes"]
});

export default new Vuex.Store({
  modules: {
    routes,
    cacheData,
    control,
    user,
    documentSign,
    file,
    process,
    doe,
    timeline,
    uploadFiles,
    downloadFiles,
    giveKnowledge,
    subscriber,
    socket,
    broadcastChannel
  },
  plugins: [dataState, userState]
});
